import { onMounted, onUnmounted } from "vue";

// ECharts bakes colours into an option at draw time, so a theme flip needs an explicit redraw
// signal. Watches html.dark directly (like Chat/composables/useChatTheme.ts) so it fires for any toggle source.
export function useThemeChange(callback: () => void) {
  let isDark = false;
  let observer: MutationObserver | null = null;

  onMounted(() => {
    isDark = document.documentElement.classList.contains("dark");
    observer = new MutationObserver(() => {
      const nowDark = document.documentElement.classList.contains("dark");
      if (nowDark === isDark) return;
      isDark = nowDark;
      callback();
    });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
  });

  onUnmounted(() => observer?.disconnect());
}
